<template>
  <div class="card mb-5">
    <div
      class="flex items-start space-x-5"
    >
      <div class="w-14 shrink-0">
        <img
          src="/img/icons/svg/windmill.svg"
          alt="Windmill"
          class="w-full"
        >
      </div>
      <div>
        <h2 class="text-gray-900 text-lg mb-0.5 font-bold">
          Carbon Offset
        </h2>
        <p class="mb-4 leading-tight text-gray-500">
          You can offset your carbon footprint with a monthly subscription.
        </p>
      </div>
    </div>
    <div class="p-5 border border-gray-200 rounded-lg">
      <p class="mb-4 text-base leading-tight text-gray-600">
        Your estimated annual carbon footprint is :
      </p>

      <div class="text-left text-gray-600">
        <p class="text-3xl font-semibold leading-none text-gray-900">
          {{ $laravel.user.carbon_footprint }}  <span class="text-lg font-normal">Tons per Year</span>
        </p>
      </div>

      <p
        class="flex space-x-2 text-sm leading-tight text-gray-500 cursor-pointer"
        @click="showExplainingModal = true"
      >
        <i class="mdi mdi-information-outline text-gray-600" />
        <span>
          How did we calculate your carbon footprint&nbsp;?
        </span>
      </p>
    </div>

    <router-link :to="'/subscription'">
      <button
        type="button"
        class="btn btn-primary w-full mt-6 text-xs"
      >
        Offset my carbon footprint
      </button>
    </router-link>

    <a
      class="btn btn-info w-full mt-3 text-xs"
      href="https://carbonii.com/"
      target="_blank"
    >
      <span>
        See the projects we support
        <i class="mdi mdi-open-in-new" />
      </span>
    </a>
  </div>

  <v-confirmation
    :show="showExplainingModal"
    @close="showExplainingModal = false"
  >
    <template #action>
      <button
        type="button"
        class="btn btn-primary w-full mt-5"
        @click="showExplainingModal = false"
      >
        Ok, got it!
      </button>
    </template>
  </v-confirmation>
</template>
<script>
import confirmation from "./confirmation-modal.vue";

export default {
  name: "v-subscribe-action",
  components: {
    "v-confirmation": confirmation
  },
  data() {
    return {
      showExplainingModal: false
    };
  }
};
</script>
